import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import unavailableIllustration from "@/assets/unavailable-illustration.png.asset.json";

export const Route = createFileRoute("/forgot-password")({
  head: () => ({
    meta: [
      { title: "Halaman Tidak Tersedia — MI Al-Munajah Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: UnavailablePage,
});

function UnavailablePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md p-8 rounded-3xl text-center shadow-[var(--shadow-elevation-2)]">
        <div className="mx-auto w-40 h-40 mb-4">
          <img
            src={unavailableIllustration.url}
            alt="Ilustrasi halaman tidak tersedia"
            className="w-full h-full object-contain"
            width={160}
            height={160}
            loading="lazy"
          />
        </div>
        <h1 className="text-2xl font-bold mb-2">Halaman Tidak Tersedia</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Halaman yang Anda tuju tidak tersedia, jika Anda mengalami kendala pada akun, silahkan hubungi admin sekolah.
        </p>
        <Button asChild className="rounded-xl">
          <Link to="/auth">Kembali ke Halaman Masuk</Link>
        </Button>
      </Card>
    </div>
  );
}
